// Basemap tile sources keyed by UI theme. Esri's Canvas (gray) services are
// keyless -- CARTO's basemaps.cartocdn.com now answers keyless requests with
// "API KEY REQUIRED" watermark tiles. Each theme is two layers: an unlabeled
// base drawn under the weather rasters and a transparent reference layer
// (labels + boundaries) drawn above them so place names stay readable.
// Note Esri's tile path order is {z}/{y}/{x}, not {z}/{x}/{y}.

const ESRI_CANVAS = "https://server.arcgisonline.com/ArcGIS/rest/services/Canvas";

/**
 * Tile URL templates + attribution for the basemap in the given theme.
 * @param {"dark"|"light"} theme  anything other than "dark" gets the light basemap
 * @returns {{ base: string, labels: string, attribution: string }}
 */
export function basemapLayers(theme) {
  const name = theme === "dark" ? "World_Dark_Gray" : "World_Light_Gray";
  return {
    base: `${ESRI_CANVAS}/${name}_Base/MapServer/tile/{z}/{y}/{x}`,
    labels: `${ESRI_CANVAS}/${name}_Reference/MapServer/tile/{z}/{y}/{x}`,
    attribution: "Tiles © Esri — Esri, HERE, Garmin, © OpenStreetMap contributors, and the GIS user community",
  };
}
